<template>
  <div class="news-search-component">
    <h4 class="menu-label has-text-right is-hidden-touch">Поиск</h4>
    <h4 class="menu-label has-text-left is-hidden-desktop">Поиск</h4>
    <!-- <p>{{ $data }}</p> -->

    <!-- <button class="button" @click="initialize">Сбросить</button> -->

    <b-field grouped>
      <b-radio-button
        class="is-expanded"
        v-model="currentSection"
        native-value="favorites"
        @input="onCurrentSectionChange"
      >
        <b-icon v-if="currentSection == 'favorites'" icon="heart"></b-icon>
        <b-icon v-else icon="heart-outline"></b-icon>
        <span>Избранное</span>
      </b-radio-button>

      <b-radio-button
        v-if="section != 'media'"
        class="is-expanded"
        v-model="currentSection"
        native-value="my-events"
        @input="onCurrentSectionChange"
      >
        <b-icon icon="account-multiple-check"></b-icon>
        <span>Мои события</span>
      </b-radio-button>
    </b-field>

    <b-field>
      <b-taginput
        v-if="section == 'announcements'"
        :readonly="false"
        v-model="selectedTags"
        :data="filteredTags"
        autocomplete
        :allow-new="false"
        :open-on-focus="true"
        field="name"
        :icon="initialized ? 'account-group' : 'dots-horizontal'"
        :placeholder="initialized ? 'Поиск по группам и курсам' : null"
        @typing="getFilteredTags"
      >
      </b-taginput>
    </b-field>
  </div>
</template>

<script>
export default Vue.extend({
  props: {
    searchTags: {
      type: Array,
      default: () => [],
    },
    readTags: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      initialized: true,
      disabled: true,
      currentSection: null,
      section: null,
      tags: [],
      filteredTags: [],
    };
  },
  watch: {
    readTags() {
      this.getFilteredTags("");
    },
    searchTags() {
      this.getFilteredTags("");
    },
    section(value) {
      this.currentSection = value;
    },
  },
  computed: {
    availableTags() {
      return _.uniqBy(_.merge(this.searchTags, this.readTags), "hash");
    },
    selectedTags: {
      set(tags) {
        this.tags = _.map(tags, "hash");

        this.$emit("tags-change", this.tags);

        this.getFilteredTags("");
      },
      get() {
        return this.availableTags.filter((tag) => {
          return this.tags.includes(tag.hash);
        });
      },
    },
  },
  methods: {
    onCurrentSectionChange(section) {
      this.$emit("section-change", section);
    },
    async updateState(delta) {
      if (delta.section) {
        this.section = delta.section;
      }

      if (delta.tags) {
        this.tags = delta.tags;
        this.getFilteredTags("");
      }
    },
    getFilteredTags(text) {
      this.filteredTags = this.availableTags
        .filter((tag) => {
          return (
            !this.tags.includes(tag.hash) &&
            tag.name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
          );
        })
        .slice(0, 10);
    },
  },
});
</script>

<style lang="sass">
.news-search-component
    .taginput.control
        .taginput-container
            padding-right: 0 !important
            .tag
                overflow: hidden
                text-overflow: ellipsis
                max-width: calc(100% - 0.375rem)
                display: inline-block
                position: relative
                padding-top: 0.3rem
                padding-right: 1.75rem
                .delete
                    position: absolute
                    right: 0.75rem
                    top: 0.5rem
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/views/news/Search.vue